import * as React from 'react';

import { getServerTranslations } from '../../get-server-side-translations';
import PaymentAndInvoices from '../../components/payment-and-invoices';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface IFlexibleSlotsProps {}

const FlexibleSlotsPage: React.FunctionComponent<IFlexibleSlotsProps> = () => <PaymentAndInvoices />;

export default FlexibleSlotsPage;

export const getStaticProps = async ({ locale }) => {
  const transConfig = await getServerTranslations(locale, ['common', 'payment-and-invoices']);
  return {
    props: {
      ...transConfig,
    },
  };
};
